module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADdSURBVHgBlVKhEsIwDE17KIYdfnpY5qdBDyxoPJ/CFGgEDjSaefQ802DHyy3lCpT2yN1bsrSveUlL9MPatk2AIf1jIEyBg6Bw7el9ECK4NZACW2AAzLg6/E4pdXNVSYES2HBs5WPJlXbeLC5F1groOw6NZe0lXSFYwOfAHlJO5O99AjcHLhqfRvJnCph1cK2FwENJQkRUzOC4lUrjlDuCK5BR2HhPDU6jJVFR12fIRqKQbGL0Ne53mbwWy96OKBcbkpsbmfxjvxwmFvzcPOSjCZQlhSc7Jr9VqPjg4Alk8oEk7/HMDwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/left-menu-8.png
// module id = 2601
// module chunks = 0